const host = {
  'start':{
    base:'http://dev.api.wuye.tiyixing.com/v1',//api接口
    vendor: 'http://apistore.bitiot.com.cn/v1',
  },
  'dev':{
    base:'http://dev.api.wuye.tiyixing.com/v1',//api接口
    vendor: 'http://apistore.bitiot.com.cn/v1',
  },
  'test':{
    base:'http://test.api.wuye.tiyixing.com/v1',
    vendor: 'http://apistore.bitiot.com.cn/v1',
  },
  'prod':{
    base:'http://api.wuye.tiyixing.com/v1',
    vendor: 'http://apistore.bitiot.com.cn/v1',
  }
}
export default host;



// WEBPACK FOOTER //
// ./src/utils/host.js